<template>
  <div class="appBlock">
    <div>
      <a-drawer
        :title="$t('Wyslij E-MAIL')"
        :width="720"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onCloseDrawer"
      >
        <a-form :formMail="formMail" layout="vertical" hide-required-mark>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item :label="$t('Do:')">
                <a-select mode="tags" :size="size" v-model="sendForm.mailTo">
                  <a-select-option v-for="item in companyMail" :key="item">{{
                    item
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item :label="$t('Temat:')">
                <a-input
                  v-decorator="[
                    'theme',
                    {
                      rules: [
                        { required: true, message: 'Please enter theme' },
                      ],
                    },
                  ]"
                  v-model="sendForm.theme"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item label="Wyslij z konta:">
                <a-dropdown :trigger="['click']">
                  <a-input
                    class="ant-dropdown-link"
                    v-decorator="[
                      'approver',
                      {
                        rules: [
                          { required: true, message: 'Please enter user mail' },
                        ],
                      },
                    ]"
                    v-model="sendForm.mailFrom"
                  />
                  <a-menu slot="overlay">
                    <a-menu-item
                      v-for="item in listMail"
                      :key="item"
                      @click="
                        () => {
                          handleChangeSetTo(item);
                        }
                      "
                      >{{ item }}</a-menu-item
                    >
                  </a-menu>
                </a-dropdown>
              </a-form-item>
            </a-col>
          </a-row>-->
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item :label="$t('Opis:')">
                <Vueditor ref="Vueditor" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-item :label="$t('Dołączone pliki i obrazy:')">
                <span
                  class="ant-form-text"
                  style="color: #1890ff; cursor: pointer"
                  @click="showChildrenDrawer"
                >
                  <a-icon type="file-word" />
                  {{ nameDocument }}
                </span>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-drawer
          :title="$t('Podgląd Prev')"
          width="60%"
          :visible="childrenDrawer"
          @close="onChildrenDrawerClose"
        >
          <a-spin :spinning="prew_doc_spinner" style="flex: 1">
            <div style="margin: 25px">
              <span v-if="!prew_doc">
                <div v-if="docPdf">
                  <canvas id="the_canvas_detail" style="display: none" />
                  <div
                    style="display: flex; justify-content: space-between"
                    v-if="!prew_doc_spinner"
                  >
                    <a-button
                      :disabled="currentPage - 1 < 1 ? true : false"
                      @click="
                        () => {
                          currentPage--;
                          getpdf('the_canvas_detail');
                        }
                      "
                    >
                      <a-icon type="left" />
                      {{ $t("Prev") }}
                    </a-button>
                    <span>{{ currentPage }} / {{ countPages }}</span>
                    <a-button
                      :disabled="currentPage + 1 > countPages ? true : false"
                      @click="
                        () => {
                          currentPage++;
                          getpdf('the_canvas_detail');
                        }
                      "
                    >
                      {{ $t("Next") }}
                      <a-icon type="right" />
                    </a-button>
                  </div>
                </div>
              </span>
              <a-empty v-else />
            </div>
          </a-spin>
        </a-drawer>
        <div
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-button :style="{ marginRight: '8px' }" @click="onCloseDrawer">
            {{ $t("ANULUJ") }}
          </a-button>
          <a-button type="primary" @click="sendingMail">
            {{ $t("WYSLIJ") }}</a-button
          >
        </div>
      </a-drawer>
    </div>
    <!-- <a-spin :spinning="spinning" size="large"> -->
    <div class="steps" v-show="!prew_history">
      <a-steps :current="current">
        <a-step
          v-for="(item, index) in steps"
          :key="item.title"
          :title="
            index < current
              ? $t('Completed')
              : index == current
              ? $t('Running')
              : $t('Awaiting')
          "
          :description="$t(item.content)"
        />
      </a-steps>
    </div>

    <div class="mainBlock--btn-top" v-show="!prew_history">
      <a-row>
        <a-col :span="12">
          <a-button v-if="current != 0" @click="handleHistoryFile">
            <a-icon type="history" />
            {{ $t("Change log") }}
          </a-button>
        </a-col>
        <a-col :span="12" style="text-align: right">
          <a-button
            v-if="[2, 3].includes(current)"
            @click="() => submit(false)"
            style="margin-right: 15px"
            icon="save"
          />
          <a-button
            v-if="[1, 2, 3].includes(current)"
            icon="eye"
            type="primary"
            :loading="loading"
            @click="showDrawerPoglad"
            style="margin-right: 15px"
          ></a-button>

          <a-button
            v-if="
              [2, 3].includes(current) && this.mailCount == 0 && rightMail == 1
            "
            type="primary"
            @click="showDrawer"
            style="margin-right: 15px"
          >
            <a-icon type="mail" />{{ $t("Mail") }}
          </a-button>
          <a-popconfirm
            placement="bottomRight"
            :ok-text="$t('Tak')"
            :cancel-text="$t('Nie')"
            v-if="this.mailCount > 0"
            @confirm="showDrawer"
          >
            <template slot="title">
              <p>
                Tą fakturą była wysłana {{ this.mailCount }} raz. Czy chcesz
                wysłać ponownie ?
              </p>
            </template>
            <a-button
              v-if="
                [2, 3].includes(current) && this.mailCount > 0 && rightMail == 1
              "
              type="primary"
              style="margin-right: 15px"
            >
              <a-icon type="mail" />Mail
            </a-button>
          </a-popconfirm>

          <a-button-group style="margin-right: 25px">
            <a-button
              v-if="current != 0 || (current == 3 && rigntEdit == 0)"
              @click="ReturnToStepBack"
              :disabled="disableFromResponsible || rightAccess == 0"
              type="primary"
            >
              <a-icon type="left" />
              {{ current == 1 ? $t("Reject") : $t("Back") }}
            </a-button>

            <a-button
              v-if="current != 3"
              :disabled="
                (checkPosition == 0 && current == 0) || rightAccess == 0
              "
              @click="() => submit(true)"
              type="primary"
            >
              {{ current == 1 ? $t("Akceptuj") : $t("Save") }}
              <a-icon type="right" />
            </a-button>
          </a-button-group>
          <a-button type="danger" icon="close" @click="back"></a-button>
        </a-col>
      </a-row>
    </div>
    <div
      v-show="!prew_history"
      class="mainBlock--form"
      style="border: 1px solid lightgray; border-radius: 5px; padding: 15px"
    >
      <div style="width: 100%">
        <saleCreate
          v-if="current == 0"
          :info="info"
          :checkMedia="checkMedia"
          :COMPANY_LIST="COMPANY_LIST"
          :MY_COMPANY_LIST="MY_COMPANY_LIST"
          :USER_LIST="USER_LIST"
          :VAT_LIST="VAT_LIST"
          :DEAL="DEAL"
          :dataSales="dataSales"
          :sale_record="sale_record"
          :user_setup="user_setup"
          ref="form"
          @generatrDoc="generatrDoc"
          @onBackMedia="onBackMedia"
          @checkPositionFunc="checkPositionFunc"
          @changeSpinning="changeSpinning"
          @onClose="onClose"
          @goSteps="goSteps"
          @onback="handlerBack"
        />
        <saleAccept
          v-if="current == 1"
          ref="form"
          :USER_LIST="USER_LIST"
          :COMPANY_LIST="COMPANY_LIST"
          :VAT_LIST="VAT_LIST"
          @changeSpinning="changeSpinning"
          @onClose="onClose"
          @generatrDoc="generatrDoc"
          :sale_record="sale_record"
          :info="info"
          :DEAL="DEAL"
          :user_setup="user_setup"
          @onback="handlerBack"
          @goSteps="goSteps"
        />
        <salePayment
          v-if="current == 2"
          ref="form"
          :profile="profile"
          :USER_LIST="USER_LIST"
          :COMPANY_LIST="COMPANY_LIST"
          :VAT_LIST="VAT_LIST"
          @changeSpinning="changeSpinning"
          @onClose="onClose"
          :sale_record="sale_record"
          :info="info"
          :DEAL="DEAL"
          :user_setup="user_setup"
          :current="current"
          @generatrDoc="generatrDoc"
          @goSteps="goSteps"
        />
        <saleArchive
          v-if="current == 3"
          ref="form"
          :profile="profile"
          :USER_LIST="USER_LIST"
          :COMPANY_LIST="COMPANY_LIST"
          :VAT_LIST="VAT_LIST"
          @changeSpinning="changeSpinning"
          @onClose="onClose"
          :DEAL="DEAL"
          :user_setup="user_setup"
          :sale_record="sale_record"
          @generatrDoc="generatrDoc"
          @onback="handlerBack"
          :info="info"
        />
      </div>
    </div>
    <salesHistory
      v-if="prew_history"
      :document="sale_record"
      :fieldColumns="fieldColumns"
      :COMPANY_LIST="COMPANY_LIST"
      :MY_COMPANY_LIST="MY_COMPANY_LIST"
      :USER_LIST="USER_LIST"
      style="padding: 15px"
      @onBack="prew_history = false"
    />
    <a-drawer
      title="Podgląd Prev"
      :visible="visiblePoglad"
      @close="onClosePoglad"
      width="60%"
    >
      <a-button
        icon="download"
        type="primary"
        @click="downloadFile()"
        :loading="loading"
        >Pobieranie pliku</a-button
      >
      <a-spin :spinning="prew_doc_spinner" style="flex: 1">
        <div style="margin: 25px">
          <span v-if="!prew_doc">
            <div v-if="docPdf">
              <canvas id="the_canvas_detail_prev" style="display: none" />
              <div
                style="display: flex; justify-content: space-between"
                v-if="!prew_doc_spinner"
              >
                <a-button
                  :disabled="currentPage - 1 < 1 ? true : false"
                  @click="
                    () => {
                      currentPage--;
                      getpdf('the_canvas_detail_prev');
                    }
                  "
                >
                  <a-icon type="left" />
                  {{ $t("Prev") }}
                </a-button>
                <span>{{ currentPage }} / {{ countPages }}</span>
                <a-button
                  :disabled="currentPage + 1 > countPages ? true : false"
                  @click="
                    () => {
                      currentPage++;
                      getpdf('the_canvas_detail_prev');
                    }
                  "
                >
                  {{ $t("Next") }}
                  <a-icon type="right" />
                </a-button>
              </div>
            </div>
          </span>
          <a-empty v-else />
        </div>
      </a-spin>
    </a-drawer>
    <div class="mainBlock--btn-bottom" v-show="!prew_history">
      <a-row>
        <a-col :span="12">
          <a-button v-if="current != 0" @click="handleHistoryFile">
            <a-icon type="history" />
            {{ $t("Change log") }}
          </a-button>
        </a-col>
        <a-col :span="12" style="text-align: right">
          <a-button
            v-if="[2, 3].includes(current)"
            @click="() => submit(false)"
            style="margin-right: 15px"
            icon="save"
          />

          <a-button
            v-if="[1, 2, 3].includes(current)"
            icon="eye"
            type="primary"
            :loading="loading"
            @click="showDrawerPoglad"
            style="margin-right: 15px"
          ></a-button>

          <a-button
            v-if="
              [2, 3].includes(current) && this.mailCount == 0 && rightMail == 1
            "
            type="primary"
            @click="showDrawer"
            style="margin-right: 15px"
          >
            <a-icon type="mail" />Mail
          </a-button>
          <a-popconfirm
            placement="bottomRight"
            ok-text="Tak"
            cancel-text="Nie"
            v-if="this.mailCount > 0"
            @confirm="showDrawer"
          >
            <template slot="title">
              <p>
                Tą fakturą była wysłana {{ this.mailCount }} raz. Czy chcesz
                wysłać ponownie ?
              </p>
            </template>
            <a-button
              v-if="
                [2, 3].includes(current) && this.mailCount > 0 && rightMail == 1
              "
              type="primary"
              style="margin-right: 15px"
            >
              <a-icon type="mail" />Mail
            </a-button>
          </a-popconfirm>
          <a-button-group style="margin-right: 25px">
            <a-button
              v-if="current != 0 || (current == 3 && rigntEdit == 0)"
              @click="ReturnToStepBack"
              :disabled="disableFromResponsible || rightAccess == 0"
              type="primary"
            >
              <a-icon type="left" />
              {{ current == 1 ? $t("Reject") : $t("Back") }}
            </a-button>

            <a-button
              v-if="current != 3"
              @click="() => submit(true)"
              type="primary"
              :disabled="
                (checkPosition == 0 && current == 0) || rightAccess == 0
              "
            >
              {{ current == 1 ? $t("Akceptuj") : $t("Save") }}
              <a-icon type="right" />
            </a-button>
          </a-button-group>
          <a-button type="danger" icon="close" @click="back"></a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import saleCreate from "./sales_steps/firstStep.vue";
import saleAccept from "./sales_steps/secondStep.vue";
import salePayment from "./sales_steps/thirdStep.vue";
import saleArchive from "@/components/sales_steps/fourthStep";
import { requestStep, getSalesHistory } from "@/requestFunc";
import salesHistory from "./salesHistory.vue";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");
export default {
  components: {
    saleCreate,
    saleAccept,
    salePayment,
    saleArchive,
    salesHistory,
  },
  props: [
    "current",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "USER_LIST",
    "VAT_LIST",
    "info",
    "profile",
    "user_setup",
    "sale_record",
    "fieldColumns",
    "DEAL",
    "checkMedia",
    "dataSales",
    "checkMediaInvoice",
  ],
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      visiblePoglad: false,
      prew_history: false,
      resultGetDoc: [],
      downloadURL: "",
      loading: false,
      timerId: 0,
      rigntEdit: 0,
      checkPosition: 0,
      companyMail: [],
      rightMail: 0,
      pdfUrlMachine: "",
      countPages: 1,
      currentPage: 1,
      mailCount: 0,
      rightAccess: 0,
      prew_doc_spinner: true,
      nameDocument: "",
      childrenDrawer: false,
      myCompanyMail: [],
      listMail: [],
      prew_doc: false,
      docPdf: true,
      sendForm: {
        run: "",
        mailTo: [],
        mailFrom: "",
        theme: "",
        message: "",
        contact: "",
        url: "",
        documentID: "",
        ID: "",
      },
      steps: [
        {
          content: "Nowa",
        },
        {
          content: "Weryfikacja",
        },
        {
          content: "Przed archiwum",
        },
        {
          content: "Archiwum",
        },
      ],
    };
  },
  methods: {
    sendingMail() {
      this.sendForm.message = this.$refs.Vueditor.getContent();
      this.sendForm.contact = this.sale_record.contractor;
      this.sendForm.ID = this.sale_record.ID;
      this.sendForm["run"] = "sendingMailFromTask";
      requestStep(this.sendForm, "./php/request.php")
        .done((data) => {
          let res = JSON.parse(data);

          this.sale_record.countMail = +this.sale_record.countMail + 1;
          this.mailCount = this.sale_record.countMail;

          if (res.status == "error") {
            this.$message.error(this.$t("E-mail nie został wysłany"));
          } else {
            this.openNotificationWithIcon("success", "bottomRight");
            this.onCloseDrawer();
            // this.$message.success("E-mail wysłany!");
          }
        })
        .always(() => {});
    },
    showDrawerPoglad() {
      this.visiblePoglad = true;
      this.getpdf("the_canvas_detail_prev");
    },
    downloadFile() {
      this.loading = true;
      if (this.sale_record.docID) {
        BX24.callMethod(
          "crm.documentgenerator.document.get",
          { id: this.sale_record.docID },
          (result) => {
            // eslint-disable-next-line
            if (result.error()) {
            } else {
              this.resultGetDoc = result.data();
              if (
                this.resultGetDoc.document.pdfUrlMachine != undefined &&
                this.resultGetDoc.document.pdfUrlMachine != null
              ) {
                this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                var link = document.createElement("a");
                link.setAttribute("href", this.pdfUrlMachine);
                link.setAttribute("download", "download");
                onload = link.click();
                this.loading = false;
              } else {
                this.timerId = setInterval(() => {
                  BX24.callMethod(
                    "crm.documentgenerator.document.get",
                    { id: this.sale_record.docID },
                    (result) => {
                      // eslint-disable-next-line
                      if (result.error()) {
                      } else {
                        this.resultGetDoc = result.data();
                        if (
                          this.resultGetDoc.document.pdfUrlMachine !=
                            undefined &&
                          this.resultGetDoc.document.pdfUrlMachine != null
                        ) {
                          this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                          var link = document.createElement("a");
                          link.setAttribute("href", this.pdfUrlMachine);
                          link.setAttribute("download", "download");
                          onload = link.click();
                          this.loading = false;
                          clearInterval(this.timerId);
                        }
                      }
                    }
                  );
                }, 5000);
              }
            }
          }
        );
      }
    },
    showDrawer() {
      this.listMail = [];
      this.companyMail = [];
      BX24.callMethod(
        "crm.company.contact.items.get",
        {
          id: this.sale_record.contractor,
        },
        (result) => {
          if (result.error()) console.error(result.error());
          else {
            let arrayIdContact = [];
            for (let item of result.data()) {
              arrayIdContact.push(item.CONTACT_ID);
            }
            let allContact = [];

            BX24.callMethod(
              "crm.contact.list",
              {
                filter: { ID: arrayIdContact },
                select: ["*", "EMAIL"],
              },
              (result) => {
                if (result.error()) console.error(result.error());
                else {
                  allContact = allContact.concat(result.data());
                  if (result.more()) {
                    result.next();
                  } else {
                    for (let itemCo of allContact) {
                      if (itemCo.EMAIL) {
                        if (itemCo.EMAIL.length != 0) {
                          for (let itemMail of itemCo.EMAIL) {
                            this.companyMail.push(itemMail.VALUE);
                          }
                        }
                      }
                    }
                  }
                }
              }
            );
          }
        }
      );
      if (this.sale_record.project) {
        BX24.callMethod(
          "crm.deal.contact.items.get",
          {
            id: this.sale_record.project,
          },
          (result) => {
            if (result.error()) console.error(result.error());
            let arrayIdContactDeal = [];
            for (let item of result.data()) {
              arrayIdContactDeal.push(item.CONTACT_ID);
            }
            let allContactDeal = [];

            BX24.callMethod(
              "crm.contact.list",
              {
                filter: { ID: arrayIdContactDeal },
                select: ["*", "EMAIL"],
              },
              (result) => {
                if (result.error()) console.error(result.error());
                else {
                  allContactDeal = allContactDeal.concat(result.data());
                  if (result.more()) {
                    result.next();
                  } else {
                    for (let itemCoD of allContactDeal) {
                      if (itemCoD.EMAIL) {
                        if (itemCoD.EMAIL.length != 0) {
                          for (let itemMailD of itemCoD.EMAIL) {
                            let resultSearch = this.companyMail.indexOf(
                              itemMailD.VALUE
                            ); // -1
                            if (resultSearch == -1) {
                              this.companyMail.push(itemMailD.VALUE);
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            );
          }
        );
      }

      let arrayUser = this.sale_record.userInfo.filter((el) => {
        if (this.sale_record.responsible == el.ID) return el;
      });

      this.myUserMail = arrayUser.length > 0 ? arrayUser[0].EMAIL : [];

      this.listMail.push(this.myUserMail);
      if (this.sale_record.docID) {
        BX24.callMethod(
          "crm.documentgenerator.document.get",
          { id: this.sale_record.docID },
          (result) => {
            // eslint-disable-next-line
            if (result.error()) {
            } else {
              this.resultGetDoc = result.data();
              this.sendForm.url = this.resultGetDoc.document.downloadUrlMachine;
              this.sendForm.documentID = this.resultGetDoc.document.id;
              this.nameDocument = this.resultGetDoc.document.title;
              this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
            }
          }
        );
      }

      this.visible = true;
      setTimeout(() => {
        this.$refs.Vueditor.setContent(this.sendForm.message);
      }, 100);
    },
    onCloseDrawer() {
      this.visible = false;
    },
    onClosePoglad() {
      this.visiblePoglad = false;
    },
    onBackMedia(data) {
      this.$emit("onBackMedia", data);
    },
    getpdf(classCanvas) {
      this.prew_doc_spinner = true;

      var url = this.pdfUrlMachine;

      //var pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
      var loadingTask = pdfjsLib.getDocument(url);
      loadingTask.promise.then(
        (pdf) => {
          try {
            this.countPages = pdf.numPages;
            if (1 <= this.currentPage && this.countPages >= this.currentPage)
              pdf.getPage(this.currentPage).then((page) => {
                var scale = 2.0;
                var viewport = page.getViewport({ scale: scale });
                var canvas = document.getElementById(classCanvas);
                var context = canvas.getContext("2d");
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                var renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                var renderTask = page.render(renderContext);
                renderTask.promise.then(() => {
                  canvas.style.display = "unset";
                });
              });
            this.prew_doc_spinner = false;
          } catch {
            this.prew_doc = true;
            this.prew_doc_spinner = false;
          }
        },
        (reason) => {
          this.prew_doc = true;
          this.prew_doc_spinner = false;
          console.error(reason);
        }
      );
    },
    ReturnToStepBack() {
      this.$emit("ReturnToStepBack");
    },
    openNotificationWithIcon(type, placement) {
      this.$notification[type]({
        message: "E-mail wysłany!",
        //description:'E-mail wysłany!',
        placement,
      });
    },
    handleChangeSetDo(item) {
      this.sendForm.mailTo = item.VALUE;
    },
    handleChangeSetTo(item) {
      this.sendForm.mailFrom = item;
    },
    showChildrenDrawer() {
      this.childrenDrawer = true;
      this.getpdf("the_canvas_detail");
    },
    onChildrenDrawerClose() {
      this.childrenDrawer = false;
    },
    handleHistoryFile() {
      this.changeSpinning();
      let doc_id = this.sale_record.ID;
      getSalesHistory(doc_id).done((x) => {
        this.changeSpinning();
        this.sale_record.HISTORY = x ? JSON.parse(x) : {};

        this.prew_history = !this.prew_history;
      });
    },
    resize() {
      BX24.resizeWindow(
        parseInt($("body #root_block").css("width")),
        parseInt($("body #root_block").css("height"))
      );
    },
    changeSpinning() {
      this.$emit("changeSpinning");
    },
    onClose(element) {
      this.$emit("onClose", element);
    },
    goSteps(element) {
      this.$emit("goSteps", element);
    },
    checkPositionFunc(element) {
      if (element) this.checkPosition = element.length;
    },
    submit(updateStatus) {
      this.$refs.form.onSubmit(updateStatus);
    },
    back() {
      if (this.checkMedia == true || this.checkMediaInvoice == true) {
        this.onBackMedia();
        this.$refs.form.onClose();
      } else {
        this.$refs.form.onClose();
      }
    },
    handleChange() {},
    popupScroll() {},
    generatrDoc(salesDocID) {
      if ([1, 2, 3].includes(this.current)) {
        this.mailCount = this.sale_record.countMail;
        this.loading = true;
        // console.log(salesDocID, 'salesDocID');
        if (salesDocID) {
          BX24.callMethod(
            "crm.documentgenerator.document.get",
            { id: salesDocID },
            (result) => {
              // eslint-disable-next-line
              if (result.error()) {
                console.error(result.error());
              } else {
                this.resultGetDoc = result.data();
                // console.log(this.resultGetDoc, 'Test');
                if (
                  this.resultGetDoc.document.pdfUrlMachine != undefined &&
                  this.resultGetDoc.document.pdfUrlMachine != null
                ) {
                  this.sendForm.url = this.resultGetDoc.document.downloadUrlMachine;
                  this.sendForm.documentID = this.resultGetDoc.document.id;
                  this.nameDocument = this.resultGetDoc.document.title;
                  this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                  this.loading = false;
                } else {
                  this.timerId = setInterval(() => {
                    BX24.callMethod(
                      "crm.documentgenerator.document.get",
                      { id: salesDocID },
                      (result) => {
                        // eslint-disable-next-line
                        if (result.error()) {
                        } else {
                          this.resultGetDoc = result.data();
                          if (
                            this.resultGetDoc.document.pdfUrlMachine !=
                              undefined &&
                            this.resultGetDoc.document.pdfUrlMachine != null
                          ) {
                            this.sendForm.url = this.resultGetDoc.document.downloadUrlMachine;
                            this.sendForm.documentID = this.resultGetDoc.document.id;
                            this.nameDocument = this.resultGetDoc.document.title;
                            this.pdfUrlMachine = this.resultGetDoc.document.pdfUrlMachine;
                            this.loading = false;
                            clearInterval(this.timerId);
                          }
                        }
                      }
                    );
                  }, 5000);
                }
              }
            }
          );
        }
      }
    },
  },
  mounted() {
    BX24.callMethod("user.admin", {}, (result) => {
      if (result.error()) console.error(result.error());
      else {
        var isAdmin = result.data();

        BX24.callMethod("user.current", {}, (result) => {
          if (result.error()) console.error(result.error());
          else {
            var userCurrent = result.data();

            if (isAdmin == true) {
              this.rightAccess = 1;
              this.rigntEdit = 1;
              this.rightMail = 1;
            } else {
              if (this.current == 0) {
                if (
                  this.user_setup.responsibleSpredz.includes(userCurrent.ID) ||
                  this.user_setup.responsibleAll.includes(userCurrent.ID)
                ) {
                  this.rightAccess = 1;
                }
              } else if (this.current == 2 || this.current == 3) {
                if (this.user_setup.responsibleAll.includes(userCurrent.ID)) {
                  this.rightAccess = 1;
                  this.rigntEdit = 1;
                  this.rightMail = 1;
                }
                if (this.current == 2) {
                  if (
                    this.user_setup.responsibleOffice.includes(userCurrent.ID)
                  ) {
                    this.rightAccess = 1;
                    this.rightMail = 1;
                  }
                }
              } else if (this.current == 1) {
                if (this.user_setup.responsibleAll.includes(userCurrent.ID)) {
                  this.rightAccess = 1;
                }
              }
            }
          }
          this.resize();
        });
      }
    });
    // eslint-disable-next-line
    BX24.callMethod("crm.deal.list", {}, (result) => {
      // eslint-disable-next-line
      if (result.error()) {
      } else {
        this.DEAL = this.DEAL.concat(result.data());
        if (result.more()) result.next();
      }
    });

    // if (this.current == 2 || this.current == 3) {
    //   this.sendForm.theme = this.sale_record.invoiceTitle;
    //   this.sendForm.message =
    //     "W dniu " +
    //     this.sale_record.billingDate +
    //     " została wygenerowana Faktura o numerze " +
    //     " " +
    //     this.sale_record.invoiceAutoNumber +
    //     ". Prosimy o wpłatę kwoty " +
    //     this.sale_record.totalAmout +
    //     " " +
    //     this.sale_record.currency +
    //     " do dnia " +
    //     this.sale_record.dueDate +
    //     ".";
    // }
    console.log(this.sale_record.docID, 'dfjkd');
    this.generatrDoc(this.sale_record.docID);
  },
};
</script>

<style scoped>
.appBlock {
  display: flex;
  text-align: left;
  flex-direction: column;
  justify-content: flex-start;
  margin: auto;
}

.appBlock .title {
  font-size: 24px;
}
.steps {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}
.steps > div:first-child {
  width: 100%;
  padding: 15px 0px;
}
.steps > div:last-child {
  align-self: center;
}
/* .mainBlock--form > div:first-child {
  display: flex;
} */
.mainBlock--btn-top {
  margin-bottom: 20px;
}
.mainBlock--btn-bottom {
  margin-top: 20px;
}
</style>
